import {FMU_CAMPAIGN_ID, FMU_INQUIRY_OBJECT} from "../constants/pardot";
import {SimpleFormProps} from "../types";
import translate from "../utils/translate";

export const EMAIL_SUBSCRIBE_CN = {
  copy: {
    title: translate(
      "Get weekly insights into all things freight, delivered right to your WeChat."
    ),
    description: translate(
      "Scan the QR code to follow Flexport on WeChat now."
    ),
  },
  darkMode: true,
};

export const EMAIL_SUBSCRIBE_DE = {
  copy: {
    title: translate("Get Free Weekly Supply Chain News Updates"),
    description: translate(
      "Subscribe for the latest news on trade lanes, customs and tariff changes, and expert economic insight."
    ),
  },
  subscriptionForm: {
    name: "email-subscribe-form",
    pardotFormHandlerUrl: null,
    title: null,
    campaignId: `${FMU_CAMPAIGN_ID}`,
    devCampaignId: `${FMU_CAMPAIGN_ID}`,
    lastInquiryObject: FMU_INQUIRY_OBJECT,
    fieldItems: [
      {
        __typename: "ContentfulFormField",
        label: translate("Work Email"),
        richTextLabel: null,
        field_name: "email",
        type: "email",
        checkForGdprCompliance: null,
        showCheckboxWithPillStyle: null,
        value: null,
        icon: null,
        required: true,
        placeholder: translate("Enter Your Work Email"),
        errorMessage: translate("Invalid email."),
        minValue: null,
        maxValue: null,
        maxLength: null,
        checked: null,
        conditionFieldName: null,
        conditionOperator: null,
        conditionExpectedValue: null,
        onlyShowForRegion: null,
        labelForTrueValue: null,
        labelForFalseValue: null,
        restrictWidth: null,
        isFullWidth: null,
      },
      {
        __typename: "ContentfulFormField",
        label: "Terms of Service and Privacy Policy",
        richTextLabel: {
          richTextLabel: translate(
            "I agree to the storing and processing of my personal data by Flexport as described in the Terms of Service and Privacy Policy."
          ),
        },
        field_name: "subscribe-term",
        type: "checkbox",
        checkForGdprCompliance: null,
        showCheckboxWithPillStyle: null,
        value: null,
        icon: null,
        required: true,
        placeholder: null,
        errorMessage: null,
        minValue: null,
        maxValue: null,
        maxLength: null,
        checked: null,
        conditionFieldName: null,
        conditionOperator: null,
        conditionExpectedValue: null,
        onlyShowForRegion: null,
        labelForTrueValue: null,
        labelForFalseValue: null,
        restrictWidth: null,
        isFullWidth: null,
      },
    ],
    stepEyebrowLabel: null,
    submitButtonLabel: translate("Subscribe"),
    postSubmissionUrl: null,
    layout: "compact",
    darkMode: true,
    errorMessage: translate("Something went wrong. Try again."),
    footnote: null,
    embedded: false,
    submittedSuccessfullyMessage: `${translate(
      "Thanks for Subscribing!"
    )} ${translate("You are now subscribed to Freight Market Updates.")}`,
    footnoteWithOrDivider: null,
  } as SimpleFormProps,
};
